export function getdata() {
	var obj = {
		searchdata:{//预留搜索

		},
		headData: [
			// {
			// 	prop: "radio",
			// 	width: 80,
			// 	custom: true,
			// },
			{
				title: "公司代码",
				prop: "companyCode",
				issort: true,
				width: 100,
			},
			{
				title: "纳税人名称",
				prop: "nsrmc",
				issort: true,
				custom: true,
				width: 160,
			},
			{
				title: "纳税人识别号",
				custom: true,
				prop: "nsrsbh",
				width: 160,
			},
			{
				title: "最近任务",
				prop: "type",
				width: 160,
				custom: true,
			},
			{
				title: "最近发起时间",
				prop: "faqTime",
				custom: true,
				width: 160,
			},
			{
				title: "任务结果",
				prop: "status",
				width: 80,
				custom: true,

			},
			{
				title: "操作",
				prop: "test6",
				custom: true,
				fixed: "right",
				width: 200,
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		syncFormDefault: {
			issueDate: '',
			invoiceType: '',
			invoiceStatus: '',
			issueStart: '',
			issueEnd: ''
		}
	}
	return obj
}
